module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "typo__label"
  }, [_vm._v("Custom Theme")]), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.themes,
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.theme),
      callback: function($$v) {
        _vm.theme = $$v
      },
      expression: "theme"
    }
  }), _c('br'), _c('br'), _c('crosstab', {
    attrs: {
      "data": _vm.data,
      "rows": _vm.rows,
      "cols": _vm.cols,
      "width": 380,
      "theme": _vm.theme
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24fd2d10"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/partials/examples/CustomTheme.vue
// module id = 59
// module chunks = 0